import { FilterTimes } from './types';

const PAGE_SIZE = 20;

const buildWhere = (searchValue: string, minTime: number, maxTime: number) => ({
  type: 'elasticsearch',
  query: {
    bool: {
      filter: [
        {
          query_string: {
            analyzer: 'standard',
            analyze_wildcard: true,
            query: searchValue,
          },
        },
        {
          range: {
            recorded: {
              gte: minTime,
              lte: maxTime,
            },
          },
        },
      ],
    },
  },
});

export const buildAuditEventsQuery = (
  searchValue: string,
  filterTimes: FilterTimes,
  searchAfterId?: number,
) => {
  const limit = [];
  searchAfterId
    ? limit.push({
        type: 'elasticsearch',
        search_after: [searchAfterId],
      })
    : limit.push({
        type: 'number',
        value: 0,
      });
  limit.push({
    type: 'number',
    value: PAGE_SIZE,
  });
  const where = buildWhere(
    searchValue,
    filterTimes.minTime,
    filterTimes.maxTime,
  );

  return {
    type: 'select',
    limit,
    columns: '*',
    from: [
      {
        table: 'audit_event',
      },
    ],
    where,
    orderby: [
      {
        type: 'DESC',
        expr: {
          type: 'column_ref',
          column: 'recorded',
        },
      },
    ],
  };
};

export const buildHistogramQuery = (
  searchValue: string,
  maxTime: number,
  minTime: number,
  interval: string,
  timeZoneOffset: string,
) => {
  const where = buildWhere(searchValue, minTime, maxTime);
  return {
    type: 'select',
    columns: [
      {
        type: 'elasticsearch',
        aggregations: {
          results: {
            date_histogram: {
              field: 'recorded',
              interval: interval,
              format: 'date_optional_time',
              time_zone: timeZoneOffset,
            },
          },
        },
      },
    ],
    from: [
      {
        table: 'audit_event',
      },
    ],
    where,
    orderby: [
      {
        type: 'DESC',
        expr: {
          type: 'column_ref',
          column: 'recorded',
        },
      },
    ],
  };
};

export const buildHistogramLimitsQuery = (
  searchValue: string,
  filterTimes: FilterTimes,
) => {
  const where = buildWhere(
    searchValue,
    filterTimes.minTime,
    filterTimes.maxTime,
  );
  return {
    type: 'select',
    columns: [
      {
        type: 'elasticsearch',
        aggregations: {
          minDate: { min: { field: 'recorded' } },
          maxDate: { max: { field: 'recorded' } },
        },
      },
    ],
    where,
    from: [
      {
        table: 'audit_event',
      },
    ],
  };
};
